<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">
      {{ isNewEmergencyContact ? 'Create' : 'Edit' }} Emergency Contact
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="firstNameInput">First Name</label>
      <input type="text" class="form-control" id="firstNameInput" name="first_name" required
             [(ngModel)]="emergencyContact.first_name">
      <div class="form-text text-danger">{{ errors.first_name }}</div>
    </div>
    <div class="form-group">
      <label for="lastNameInput">Last Name</label>
      <input type="text" class="form-control" id="lastNameInput" name="last_name" required
             [(ngModel)]="emergencyContact.last_name">
      <div class="form-text text-danger">{{ errors.last_name }}</div>
    </div>
    <div class="form-group">
      <label for="telephoneInput">Telephone</label>
      <input type="text" class="form-control" id="telephoneInput" name="telephone" required
             [(ngModel)]="emergencyContact.telephone">
      <div class="form-text text-danger">{{ errors.telephone }}</div>
    </div>
    <div class="form-group">
      <label for="emailInput">Email (Optional)</label>
      <input type="text" class="form-control" id="emailInput" name="email" required
             [(ngModel)]="emergencyContact.email">
      <div class="form-text text-danger">{{ errors.email }}</div>
    </div>
    <div class="form-group">
      <label for="relationInput">Relation (Optional)</label>
      <input type="text" class="form-control" id="relationInput" name="relation" required
             [(ngModel)]="emergencyContact.relation">
      <div class="form-text text-danger">{{ errors.relation }}</div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-danger"
            *ngIf="!loadingSubmit && !isNewEmergencyContact"
            (click)="handleRemove()">
      Remove
    </button>
    <button type="button" class="btn btn-danger disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingSubmit"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
